import { PubListConfigInternal } from 'PubListGenerator/types';

export enum UserProfileTabs {
  WORK = 'work',
  PUBLIST = 'publist',
}

export type PubListKeyConfigMap = Map<string, PubListConfigInternal>;
